import { Box } from '@material-ui/core';

import { content } from '@content';
import { Typography } from '@components';

import { ModulesListProps } from './ModulesList.props';
import { useStyles } from './ModulesList.styles';
import { useEffect, useState } from 'react';

/**
 ModulesList component.
 @returns {JSX.Element}
 */

export const ModulesList = ({ list }: ModulesListProps) => {
  const styles = useStyles();
  const [formattedList, setFormattedList] = useState<any[]>([]);

  useEffect(() => {
    const curFormattedList = list.map((item) => ({
      ...item,
      modules: item.modules.map((module) => ({
        ...module,
        formattedModuleTemplateName:
          // (module.moduleTemplateName ?? '').length > 50
          //   ? `...${module.moduleTemplateName?.slice(
          //       module.moduleTemplateName.length - 50,
          //       module.moduleTemplateName.length,
          //     )}`
          //   : module.moduleTemplateName,
          module.moduleTemplateName,
      })),
    }));

    setFormattedList(curFormattedList);
  }, [list]);

  return (
    <Box className={styles.modulesList}>
      {formattedList.length &&
        formattedList.map((item, index) => (
          <Box key={index}>
            <Typography.Caption className={styles.title}>{item.experienceName}</Typography.Caption>
            <Box className={styles.section}>
              {item.modules.length > 0
                ? item.modules.map((module: any) => (
                    <Box className={styles.row} key={module.id}>
                      {module.contentStatus === 'none' ? (
                        <>
                          <Typography.SuperSmallCaption className={styles.moduleName} component={'span'}>
                            {module.name}:
                          </Typography.SuperSmallCaption>
                          <Typography.Caption component={'span'}>{content.contentNotAdded}</Typography.Caption>
                        </>
                      ) : (
                        <>
                          <Typography.SuperSmallCaption className={styles.moduleName} component={'span'}>
                            {module.name}:
                          </Typography.SuperSmallCaption>
                          <Typography.Caption component={'span'}>
                            {module.formattedModuleTemplateName}
                          </Typography.Caption>
                        </>
                      )}
                    </Box>
                  ))
                : null}
            </Box>
          </Box>
        ))}
    </Box>
  );
};
